<template>
  <!-- START : Build Your Item Wrap -->
  <div v-if="fetched && updated && item">
    <!-- START : Build Now Items Tab Wrap -->
    <WCItemModifier
      v-model="instructions"
      :itemModifiers="itemModifiers"
      :item="item"
      :instructions="instructions"
      :isEditing="editingItem"
      @clearAll="clearSelected"
    >
      <!-- START : Add To Cart Btn -->
      <template #addToCartBtn>
        <!-- START : Selection Qty Increment & Add to cart -->
        <div class="d-flex">
          <div class="text-nowrap ml-3">
            <!-- START : Add to list button -->
            <WCAddToListButton
              v-if="hasAddToList"
              :item="item"
              :isFavoriteMTOItem="isFavoriteMTOItem"
              :btnVarient="addToListBtnType"
              :editingItem="editingItem"
              :itemModifiers="itemModifiers"
              :instructions="instructions"
              :disabled="!allValid"
              @close="goBack"
            />
            <!-- END : Add to list button -->
            <!-- START : Add to cart -->
            <WCItemModifierAddToCartButton
              v-else
              :lineItem="lineItem"
              :item="item"
              :editingItem="editingItem"
              :itemModifiers="itemModifiers"
              :instructions="instructions"
              @click="goBack"
            />
            <!-- END : Add to cart -->
          </div>
        </div>
        <!-- END : Selection Qty Increment & Add to cart -->
      </template>
      <!-- END : Add To Cart Btn -->
    </WCItemModifier>
  </div>
  <!-- END : Build Your Item Wrap -->
  <!-- START : Loader -->
  <WCSpinner v-else position="center" size="xl" />
  <!-- END : Loader -->
</template>

<script>
import WCAddToListButton from '@/modules/lists/components/WCAddToListButton/WCAddToListButton.vue';
import WCItemModifier from '@/modules/itemModifiers/components/WCItemModifier/WCItemModifier.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCItemModifierAddToCartButton from '@/modules/itemModifiers/components/WCItemModifierAddToCartButton/WCItemModifierAddToCartButton.vue';
import ItemModifierRootMixin from '@/modules/itemModifiers/mixins/ItemModifierRootMixin';

export default {
  components: {
    WCItemModifier,
    WCItemModifierAddToCartButton,
    WCSpinner,
    WCAddToListButton,
  },
  props: {
    isFavoriteMTOItem: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['goBack'],
  mixins: [ItemModifierRootMixin],
  methods: {
    /**
     * To emit goBack on Add to Cart or back
     */
    goBack() {
      this.$emit('goBack');
    },
  },
};
</script>
